export const parseTimeToMs = (timeStr) => {
  const parts = timeStr.split(":").map(Number).reverse();
  let ms = 0;

  if (parts.length >= 1) ms += parts[0] * 1000;
  if (parts.length >= 2) ms += parts[1] * 60000;
  if (parts.length >= 3) ms += parts[2] * 3600000;

  return ms;
};

export const parseMsToTime = (ms) => {
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  const pad = (n) => n.toString().padStart(2, "0");
  if (ms >= 3600000) {
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  } else if (ms >= 60000) {
    return `${pad(minutes)}:${pad(seconds)}`;
  } else {
    return `${pad(seconds)}`;
  }
};

export const parseMsToWord = (ms) => {
  if (ms >= 3600000) {
    return `${Math.floor(ms / 3600000)} hours`;
  } else if (ms >= 60000) {
    return `${Math.floor((ms % 3600000) / 60000)} minutes`;
  } else {
    return `${Math.floor((ms % 60000) / 1000)} seconds`;
  }
};

export function formatCurrency(value, currency = 'USD', locale = 'en-US', fromCents = false) {
  if (value == null || value === '') return '$0';

  const num = typeof value === 'string'
    ? parseFloat(value.replace(/[^0-9.-]/g, ''))
    : Number(value);

  if (isNaN(num)) return '$0';

  const amount = fromCents ? num / 100 : num;
  const fractionDigits = amount % 1 === 0 ? 0 : 2;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function viewPortObserver (componentInstance, sectionIds) {
  const options = {
    root: null,
    threshold: 0.35,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {   
      if (entry.isIntersecting) {
        const sectionId = entry.target.id;
        const newHash = `#${sectionId}`;

        if (componentInstance.$route.hash !== newHash) {          
          componentInstance.$router.replace({
            path: componentInstance.location.pathname,
            hash: newHash,
          });
        }
      }
    });
  }, options);

  sectionIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  return observer;
}

export function normalizeScore(score, kpiRange = 'standard') {
  if (kpiRange === 'expanded') {
    return Math.round(score / 3);
  }

  return Math.min(score, 7);
}

export function formatPhone(value) {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 3) {
    return digits ? `(${digits}` : "";
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function normalizePhone(value) {
  if (!value) return "";
  return String(value).replace(/\D/g, "").slice(0, 10);
}

export function formatDisplayDate(dateISO) {
  if (!dateISO) return '';

  return new Date(dateISO).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

export function calculateYearsInBusiness(establishedDate) {
  if (!establishedDate) return null
  const established = new Date(establishedDate)
  if (isNaN(established.getTime())) return null
  const now = new Date()
  const years = now.getFullYear() - established.getFullYear()
  const hasHadAnniversary =
    now.getMonth() > established.getMonth() ||
    (now.getMonth() === established.getMonth() && now.getDate() >= established.getDate())
  const result = hasHadAnniversary ? years : years - 1
  return result < 1 ? '< 1' : result
}

export function formatBusinessAttributes(business) {
  if (!business) return {}
  return {
    entity: business.entity
      ? business.entity.replace(/_/g, ' ').toUpperCase()
      : null,
    yearsInBusiness: calculateYearsInBusiness(business.established_date),
    companySize: business.company_size
      ? business.company_size.replace(/_/g, '-')
      : null,
    annualRevenue: business.annual_revenue
      ? formatCurrency(business.annual_revenue)
      : null,
  }
}

export function formatAndRoundCurrency(value) {
  const numeric = parseFloat(value)
  const rounded = isNaN(numeric) ? 0 : Math.round(numeric)
  return {
    raw: rounded,
    formatted: rounded.toLocaleString('en-US'),
  }
}
